/**
 * bootprompt.js locale configuration
 * locale : Turkish
 * author : Enes Karaca
 */

import { addLocale } from "../bootprompt";

addLocale("tr", {
  OK: "Tamam",
  CANCEL: "İptal",
  CONFIRM: "Onayla",
});
